<template>
    <div class="h-table">
        <el-table
			 ref="multipleTable"
			 @selection-change="handleSelectionChange"
			:data="tableData2"
			stripe
			style="width: 100%"
			>
			<el-table-column
			  type="selection"
			  width="55"
			  label="全选"
			  >
			</el-table-column>
			<el-table-column
			  fixed
			  type="index"
			  label="序号"
			  width="150">
			</el-table-column>
			<el-table-column
			  prop="hnumber"
			  label="回款编号"
			  width="200">
			</el-table-column>
			<el-table-column
			  prop="status"
			  label="认领状态"
			  width="120">
			  <template slot-scope="scope">
				<el-tag
				  :type="scope.row.status === '待认领' ? 'h_tabRedFont' :(scope.row.status === '已认领' ? 'h_tabGreenFont' : 'h_tabBlueFont')"
				  disable-transitions>{{scope.row.status}}</el-tag>
			  </template>
			</el-table-column>
			<el-table-column
			  prop="type"
			  label="回款类型"
			  width="120">
			</el-table-column>
			<el-table-column
			  prop="time"
			  label="认领时间"
			  width="250">
			</el-table-column>
			<el-table-column
			  prop="time2"
			  label="回款时间"
			  width="250">
			</el-table-column>
			<el-table-column
			  prop="customer"
			  label="所属客户"
			  width="120">
			</el-table-column>
			<el-table-column
			  label="操作"
			  fixed="right"
			  >
			  <template slot-scope="scope">
				<el-button
				  type="text"
				  size="small"
				  class="h-tableLink">
						查看
				</el-button>
				<el-button
				  type="text"
				  size="small"
				  class="h-tableLink">
						认领
				</el-button>
				<el-button
				  type="text"
				  size="small"
				  class="h-tableLink">
						发起认领
				</el-button>
			  </template>
			</el-table-column>
		  </el-table>
          <span class="h-pagiLabel">显示数量:</span>
		<!--<pages></pages>-->
    </div>
</template>
<script>
export default {
    data(){
        return {
            multipleSelection: [],
            tableData2: [{
                hnumber: 'GH897456666',
                status:'待认领',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            },{
                hnumber: 'GH897456666',
                status:'已认领',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            }, {
                hnumber: 'GH897456666',
                status:'认领中',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            }, {
                hnumber: 'GH897456666',
                status:'待认领',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            }],
        }
    },
    methods:{
		handleSelectionChange(val) {
			this.multipleSelection = val;
		  },
	}
}
</script>
<style>

</style>